import VariacaoService from "@/services/VariacaoService";

export const variacao = {
  namespaced: true,
  state: {
    variacao: {},
  },
  actions: {
    getVariacao({ commit }, payload) {
      return VariacaoService.GetVariacao(payload).then(
        (variacao) => {
          return Promise.resolve(variacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postVariacao({ commit }, payload) {
      return VariacaoService.PostVariacao(payload).then(
        (variacao) => {
          return Promise.resolve(variacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putVariacao({ commit }, payload) {
      return VariacaoService.PutVariacao(payload).then(
        (variacao) => {
          return Promise.resolve(variacao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteVariacao({ commit }, payload) {
      return VariacaoService.DeleteVariacao(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getVariacaoOData({ commit }, payload) {
      return VariacaoService.GetVariacaoOData(payload).then(
        (variacao) => {
          return Promise.resolve(variacao);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default variacao;
